import CardPaymentModel from "./CardPaymentModel";

export default CardPaymentModel;
